import { useState } from 'react';
import styles from './OddEvenToggle.module.css';

export function OddEvenToggle() {
  const [pick, setPick] = useState<'odd' | 'even' | null>(null);
  return (
    <section className={styles.section} data-testid="odd-even-section">
      <h2>Odd or even?</h2>
      <div className={styles.row} role="radiogroup" aria-label="Odd or even">
        <button
          type="button"
          role="radio"
          aria-checked={pick === 'odd'}
          aria-pressed={pick === 'odd'}
          onClick={() => setPick(pick === 'odd' ? null : 'odd')}
          className={styles.button}
          data-testid="odd-button"
        >
          Odd
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={pick === 'even'}
          aria-pressed={pick === 'even'}
          onClick={() => setPick(pick === 'even' ? null : 'even')}
          className={styles.button}
          data-testid="even-button"
        >
          Even
        </button>
      </div>
    </section>
  );
}
